<div #target="tooltipTarget" [igxTooltipTarget]="tooltipRef" [id]="id">
  <button [disabled]="isDisabled()" (click)="runAction()" igxButton="outlined" igxRipple igxRippleCentered="true">
    <igx-icon fontSet="material">{{ icon }}</igx-icon>
  </button>
</div>

<div #tooltipRef="tooltip" igxTooltip>
  {{ currentTooltip }}
</div>